<app-item [entity]="entity" [deleteService]="deleteService" [deleteButtonInMore]="true">
    <ng-container buttons>

        <ng-container *ngIf="notPaidPaymentRequests.length > 0">
            <div *ngFor="let paymentRequest of notPaidPaymentRequests" style="display: flex; gap: 10px;">
                <app-button (clickEvent)="pay(paymentRequest)"
                            iconName="credit-card"
                            fill="solid"
                            color="primary"
                            tooltip="{{paymentRequest.description + (paymentRequest.communication ? (' (communication: ' + paymentRequest.communication + ')') : '')}}"
                            label="{{paymentRequest.balance}} €">
                </app-button>
            </div>
        </ng-container>
        <ng-container *ngIf="!entity.sale.isWaitingForConfirmation() && entity.sale.isAcceptedOrAbove()">
            <app-button (click)="newInvoice()"
                        *ngIf="entity.sale.invoices.length === 0"
                        iconName="plus" fill="solid" color="primary" tooltip="Facture"></app-button>
            <app-document-download fill="solid" label="D" *ngIf="entity.sale.purchaseOrders?.length > 0 && entity.sale.purchaseOrders[0].document" color="primary" [entity]="entity.sale.purchaseOrders[0].document"></app-document-download>
        </ng-container>
        <app-document-download fill="solid" label="F" *ngIf="entity.sale.invoices?.length > 0 && entity.sale.invoices[0].document" color="primary" [entity]="entity.sale.invoices[0].document"></app-document-download>
        <ng-container *ngIf="entity.sale.isWaitingForConfirmation()">
            <app-button
                    tooltip="Accepté par le patient"
                    [entity]="entity"
                    color="primary"
                    fill="solid"
                    iconName="check"
                    (clickEvent)="accept()">
            </app-button>
            <app-action-button
                    fill="solid"
                    tooltip="Refusé par le patient"
                    [confirmationOptions]="undefined"
                    [entity]="entity"
                    iconName="x"
                    [service]="chargedActSetStatusService"
                    [buildPayload]="buildRefusedPayload"
                    (actionSuccessEvent)="statusChanged($event)">
            </app-action-button>
        </ng-container>
    </ng-container>
    <app-button buttons iconName="signature" *ngIf="entity.toBeSigned && !entity.signed" tooltip="Signer" (clickEvent)="sign()" fill="solid" color="primary"></app-button>
    <ng-container more-buttons>
        <app-button (click)="sendPurchaseOrderByEmail()" *ngIf="entity.sale.purchaseOrders.length > 0"
                    tooltip="Envoyer par e-mail" label="Devis" iconName="mail"></app-button>
            <app-button (click)="sendInvoiceByEmail()" label="Facture" *ngIf="entity.sale.invoices.length > 0"
                        tooltip="Envoyer par e-mail"
                        iconName="mail"></app-button>
    </ng-container>


    <app-summary [expandable]="true" [expanded]="false">
        <ng-container title>
            <ng-container *ngIf="entity.sale.isWaitingForConfirmation()">Devis</ng-container>
            <ng-container *ngIf="entity.sale.isAcceptedOrAbove()">Facturation</ng-container>
        </ng-container>
        <ng-container content>
            <div class="d-flex align-items-center w-100 flex-wrap">
                    <app-price-summary-field [iconName]="entity.sale.balance > 0 ? 'x' : 'check'" [color]="entity.sale.balance > 0 ? 'danger' : 'success'" [price]="entity.sale.totalPriceVatIncluded"></app-price-summary-field>
                    <app-date-label [date]="entity.sale.date" *ngIf="displayDate"></app-date-label>
            </div>
        </ng-container>
        <ng-container expandedContent>
            <div class="d-flex align-items-center gap">
                <app-product-summary-field *ngFor="let saleProduct of entity.products"
                                           [entity]="saleProduct.product"></app-product-summary-field>
                <app-price-summary-field *ngIf="entity.sale.balance" color="danger" label="Reste à payer" [price]="entity.sale.balance"></app-price-summary-field>
            </div>

            <ng-container *ngIf="entity.sale.balance > 0 && entity.sale.status.value !== SALE_STATUS.SALE_STATUS_CANCELLED && entity.sale.status.value !== SALE_STATUS.SALE_STATUS_REFUSED">
                <div>
                    <ng-container *ngIf="notPaidPaymentRequests.length > 0">
                        <div *ngFor="let paymentRequest of notPaidPaymentRequests" style="display: flex; gap: 10px;">
                            <app-lov-value-summary-field *ngIf="paymentRequest.thirdPartyPaymentType" label="Payable par" [lovValueSummary]="paymentRequest.thirdPartyPaymentType"></app-lov-value-summary-field>
                            <app-partner-summary-field label="Assigné à" [partnerSummary]="paymentRequest.thirdPartyPartner" *ngIf="paymentRequest.thirdPartyPartner"></app-partner-summary-field>
                            <!-- <app-button (clickEvent)="pay(paymentRequest)"
                                        iconName="credit-card"
                                        fill="solid"
                                        tooltip="{{paymentRequest.description + (paymentRequest.communication ? (' (communication: ' + paymentRequest.communication + ')') : '')}}"
                                        label="Encaisser {{paymentRequest.balance}} €">
                            </app-button> -->
                        </div>
                    </ng-container>
                </div>
            </ng-container>
            <div *ngIf="paidPaymentRequests.length > 0">
                <strong style="font-size: 12px; font-family: Inter;">Paiements reçus</strong>
                <ng-container *ngFor="let paymentRequest of paidPaymentRequests">
                    <app-charged-act-summary-paid-payment-request
                            [paymentRequest]="paymentRequest"
                            [chargedAct]="entity"></app-charged-act-summary-paid-payment-request>
                </ng-container>
            </div>
        </ng-container>
    </app-summary>
</app-item>
